import React from 'react';
import Svg, { Path } from 'react-native-svg';

interface CloseIconProps {
  width?: number;
  height?: number;
  color?: string;
}

const CloseIcon: React.FC<CloseIconProps> = ({
  width = 16,
  height = 16,
  color = '#332D6F',
}) => {
  return (
    <Svg width={width} height={height} viewBox="0 0 16 16" fill="none">
      <Path
        d="M12 4.00003L4 12M3.99997 4L11.9999 12"
        stroke={color}
        strokeLinecap="round"
      />
    </Svg>
  );
};

export default CloseIcon;
